module.exports = __webpack_public_path__ + "static/media/hoc5.1fe7ac84.jpg";